// extracted by mini-css-extract-plugin
module.exports = {"tabsItem":"TabsItem--tabsItem--15lVH","active":"TabsItem--active--28lhD","placeholderAnim":"TabsItem--placeholderAnim--4etZb"};